<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item" 
        :class="{'visible': imageVisible[index]}"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          :alt="'Image ' + (index + 1)"
          class="collage-image"
        >
      </div>
    </div>

    <!-- Modal para mostrar la imagen ampliada -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      isImageEnlarged: false,
      images: [
        require('@/assets/ppp.webp'),
        
      ],
      imageVisible: Array(4).fill(false), // Ajusta la cantidad según el número de imágenes
    };
  },
  mounted() {
    this.initObserver();
  },
  methods: {
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
    enlargeImage(index) {
      this.currentIndex = index;
      this.isImageEnlarged = true;
    },
    closeModal() {
      this.isImageEnlarged = false;
    },
    // Inicia el IntersectionObserver para detectar cuando las imágenes son visibles
    initObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,  // Cuando al menos 50% de la imagen sea visible
      };

      const observer = new IntersectionObserver(this.handleIntersection, options);
      this.$refs.collageItems.forEach(item => observer.observe(item));
    },
    // Maneja la intersección de las imágenes con el viewport
    handleIntersection(entries) {
      entries.forEach(entry => {
        const index = this.$refs.collageItems.indexOf(entry.target);
        if (entry.isIntersecting) {
          this.imageVisible[index] = true; // Marca la imagen como visible
          this.resetImageAnimation(index); // Resetea la animación al ser visible
        }
      });
    },
    // Resetea la animación de la imagen al hacerla visible nuevamente
    resetImageAnimation(index) {
      const collageItem = this.$refs.collageItems[index];

      // Eliminar la clase de animación si está presente
      collageItem.classList.remove('animate-in');

      // Forzar el reflujo para reiniciar la animación
      void collageItem.offsetHeight; // Forzar el reflujo

      // Usamos un retraso para asegurar que la animación se reinicie correctamente
      setTimeout(() => {
        collageItem.classList.add('animate-in'); // Re-agregar la clase de animación
      }, 50); // Retraso pequeño para permitir que el navegador "procese" el cambio
    }
  },
};
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 90%;
  max-width: 1000px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 30px;
}

.collage-grid {
  display: grid;
  gap: 20px;
  position: relative;
}

.collage-item {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  margin-bottom: 5px;
  cursor: pointer;
  opacity: 0; /* Inicia invisible */
  transform: translateY(30px); /* Inicia desplazada hacia abajo */
  transition: opacity 1s ease-out, transform 1s cubic-bezier(0.68, -0.55, 0.27, 1.55); /* Transición con efecto rebote */
}

.collage-item.visible {
  opacity: 1; /* Se hace visible */
  transform: translateY(0) scale(1); /* Vuelve a su posición original con efecto de rebote */
}

.collage-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

/* Animación de aparición */
.collage-item {
  opacity: 0;
  transition: opacity 1s ease-in-out; /* Transición de opacidad */
}

.collage-item.visible {
  opacity: 1; /* Se hace visible */
}

/* Modal de imagen ampliada */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.enlarged-image {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
  border-radius: 10px;
}
</style>
